import { createLogger } from "../utils";
// interface AtsService<
// T1 extends IBaseDataLayer = IBaseDataLayer,
// T2 extends string = never
// > {
//    readonly name: string;
//    readonly context: IAdtechStack<T1, T2>;
//    readonly logger: ILogger;
// }
// interface IBootstrappable {
//   async bootstrapInstance
// }
class Service {
    constructor(name, context) {
        this.name = name;
        this.context = context;
        this.logger = createLogger(this.name);
        this.logger.logInfo(`Starting ${this.name} service`);
    }
    static buildService(config
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ) { }
}
export default Service;
//# sourceMappingURL=service.js.map